import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { ConsentEvent, DisplayConsents, FlyoutOpeningData, PersonDetails, SessionDetails } from '../flyout-models';
import { Subscription } from 'rxjs';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-consent-list',
  templateUrl: './flyout-consent-list.component.html',
  styleUrls: ['./flyout-consent-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutConsentListComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private _openingData: FlyoutOpeningData;
  public personDetails: PersonDetails;
  private personSubscription: Subscription;
  private sessionDetails: SessionDetails;
  private sessionSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public consents: Array<ConsentEvent>;
  public displayConsents: Array<DisplayConsents>;
  public consentsToShow: Array<DisplayConsents>;
  public index = 0;
  public spanStart: number;
  public spanEnd: number;
  public expandedTab: string;

  @Input()
  public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this._openingData = openingData;
    this.expandedTab = this._openingData?.expandedTab;
  }

  public get flyoutOpeningData(): FlyoutOpeningData {
    return this._openingData;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutActionListComponent');
  }

  ngOnInit() {
    this.sessionSubscription = this.flyoutService.sessionDetailsBS.subscribe((sessionDetails: SessionDetails) => {
      this.sessionDetails = sessionDetails;
      this.processStatistics();
    });
    this.personSubscription = this.flyoutService.personDetailsBS.subscribe((personDetails: PersonDetails) => {
      this.personDetails = personDetails;
      this.processStatistics();
    });
    this.populateConsentsToShow();
  }

  private processStatistics() {
    if (this.sessionDetails && this.sessionDetails.consents) {
      const consents = JSON.parse(JSON.stringify(this.sessionDetails.consents));
      this.consents = consents.reverse();
    } else if (this.personDetails && this.personDetails.consents) {
      const consents = JSON.parse(JSON.stringify(this.personDetails.consents));
      this.consents = consents.reverse();
    }
  }

  public populateConsentsToShow(): void {
    const consentsToShow = [];
    for (const consent of this.consents) {
      if (!consentsToShow.find((x) => x.latestConsent.revisionNumber === consent.revisionNumber)) {
        const tempConsent: DisplayConsents = {};
        tempConsent.latestConsent = consent;
        const array = this.consents.filter((x) => x.revisionNumber === consent.revisionNumber);
        array.sort((a, b) => a.formattedTimestamp.localeCompare(b.formattedTimestamp));
        tempConsent.firstConsent = array[0];
        tempConsent.timesConsented = array.length;
        consentsToShow.push(tempConsent);
      }
    }
    this.displayConsents = consentsToShow.sort((a, b) => b.latestConsent.time.localeCompare(a.latestConsent.time));
    this.spanStart = this.index + 1;
    this.spanEnd = this.index + 2;
    this.consentsToShow = this.displayConsents.slice(this.index, this.index + 2);
  }

  public navigateConsents(add: boolean) {
    if (add && this.index < this.displayConsents.length - 2) {
      this.index = this.index + 2;
    } else if (!add && this.index > 0) {
      this.index = this.index - 2;
    } else {
      return;
    }
    this.spanStart = this.index + 1;
    if (this.index < this.displayConsents.length - 2) {
      this.spanEnd = this.index + 2;
    } else {
      this.spanEnd = this.displayConsents.length;
    }
    this.consentsToShow = this.displayConsents.slice(this.index, this.index + 2);
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.personSubscription, this.sessionSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
